import { gql } from '@apollo/client';

export const REMOVE_USERV2_FROM_ACCESS_GROUP = gql`
  mutation RemoveUserv2($removeUserv2Input2: RemoveUserFromAccessGroupInput!) {
    removeUserv2(input: $removeUserv2Input2) {
      message
      item
      isSuccess
    }
  }
`;
